import { EmptyTitle } from '../../layout/Title';
import { StyledCreate } from '../propays/NewProPayForm';
import { AutomationForm } from './automations';

const automationContent = {
    title:'New Automation',
    startNowButtonText:'',
    draftButtonText:'',
    deleteButtonText:'',

}

const AutomationCreateView = (props) => {
    return (
        <>
            <StyledCreate
                component="div"
                {...props}
                title={<EmptyTitle />}
                mutationMode="pessimistic"
                // transform={}
            >
                <AutomationForm record={null}  content={automationContent}/>
            </StyledCreate>
            create view
        </>
    );
};

export default AutomationCreateView;
